var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm._f("capitalize")(_vm.$t(_vm.tooltip))}},[_c('feather-icon',{class:_vm.customClass || null,style:(_vm.customStyle || null),attrs:{"icon":_vm.icon,"svgClasses":"hover:opacity-80 cursor-pointer action-block"},on:{"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }